module.exports = __webpack_public_path__ + "media/video-clavier.33b7df8a.mp4";